import { createRouter, createWebHashHistory } from 'vue-router'



import addCustomer from './views/addCustomer.vue'
import bindCustomer from './views/bindCustomer.vue'
// 按功能模块分组导入组件
// 客户相关
import customerDetail from './views/customerDetail.vue'
import customerEdit from './views/customerEdit.vue'


import storeAmountLog from './views/storeAmountLog.vue'
import zengAmountLog from './views/zengAmountLog.vue'
// 订单相关
import orderList from './views/orderList.vue'
import orderDetail from './views/orderDetail.vue'

import confirmOrder from './views/confirmOrder.vue'

// 预约相关
import appointmentList from './views/appointmentList.vue'

// 积分相关
import customerPoint from './views/customerPoint.vue'

// 商品/服务相关
import choseProduct from './views/choseProduct.vue'
import choseService from './views/choseService.vue'

// 卡券相关
import choseCard from './views/choseCard.vue'
import customerDiscountCardList from './views/customerDiscountCardList.vue'
import customerCikaList from './views/customerCikaList.vue'
import customerCouponList from './views/customerCouponList.vue'
import discountCardList from './views/discountCardList.vue'

import choseCoupon from './views/choseCoupon.vue'
import couponSend from './views/couponSend.vue'
import sendCard from './views/sendCard.vue'

// 客户互动相关
import followList from './views/followList.vue'
import followAdd from './views/followAdd.vue'

// 其他功能
import makeRecharge from './views/makeRecharge.vue'
 
import signList from './views/signList.vue'

// 2. 定义路由配置
// 每个路由都需要映射到一个组件
const routes = [



  // 客户相关路由
  { path: '/customerDetail', component: customerDetail },
  { path: '/customerEdit', component: customerEdit },
  { path: '/addCustomer', component: addCustomer },
 { path: '/bindCustomer', component: bindCustomer },
  // 客户余额相关路由
  { path: '/storeAmountLog', component: storeAmountLog },
  { path: '/zengAmountLog', component: zengAmountLog },


  // 订单相关路由
  { path: '/orderList', component: orderList },
  { path: '/orderDetail', component: orderDetail },
  { path: '/confirmOrder', component: confirmOrder },

  // 预约相关路由
  { path: '/appointmentList', component: appointmentList },

  //积分相关
  { path: '/customerPoint', component: customerPoint },

  // 商品/服务相关路由
  { path: '/choseProduct', component: choseProduct },
  { path: '/choseService', component: choseService },

  // 卡券相关路由
  { path: '/choseCard', component: choseCard },
  { path: '/customerDiscountCardList', component: customerDiscountCardList },
  { path: '/customerCikaList', component: customerCikaList },
  { path: '/discountCardList', component: discountCardList },
  { path: '/customerCouponList', component: customerCouponList },
  { path: '/choseCoupon', component: choseCoupon },
  { path: '/couponSend', component: couponSend },
  { path: '/sendCard', component: sendCard },

  // 客户互动相关路由
  { path: '/followList', component: followList },
  { path: '/followAdd', component: followAdd },

  // 其他功能路由
  { path: '/makeRecharge', component: makeRecharge },
 
  { path: '/signList', component: signList },

  // 默认路由
  { path: '/', redirect: '/customerDetail' }
]

// 3. 创建路由实例
const router = createRouter({
  // 使用 hash 模式
  history: createWebHashHistory(),
  routes
})

export default router